import { render, staticRenderFns } from "./TabEnviosAutomaticos.vue?vue&type=template&id=4524e48e"
import script from "./TabEnviosAutomaticos.vue?vue&type=script&lang=ts"
export * from "./TabEnviosAutomaticos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports